import React, { ReactElement } from 'react'

interface DiamondWrapperInterface {
  children: React.ReactElement
  className: string
};

const DiamondWrapper = ({ className, children }: DiamondWrapperInterface): ReactElement => (
  <div className='glow-effect w-full md:w-auto'>
    <div className='relative diamond-corner min-h-[400px] w-full max-w-[440px] mx-auto md:max-w-full md:min-w-[670px] p-[4px] bg-dopage-lightGreen shadow-[0px_0px_20px_-4px_rgba(52,232,158,1)]}'>
      <div className={`inner bg-black w-full h-auto md:h-[580px] ${className || ''}`} data-testid='diamond-wrapper-inner'>
        {children}
      </div>
    </div>
  </div>
)

export default DiamondWrapper
